import { HttpClient } from "@angular/common/http";
import { Injectable, inject, signal } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { delay, Observable, of } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class TranslationService {
  public translatedArray: any = [];
  public languageType: string = "";
  readonly translationState = signal<any>([]);
  readonly sharetranslationData = toObservable(this.translationState);
  readonly translationContent = this.sharetranslationData;
  readonly languageState = signal<any>("");
  readonly sharelanguageType = toObservable(this.languageState);
  readonly languageContent = this.sharelanguageType;
  private _featureFlags: any = { locations: {}, events: {}, profile: {} };
  private _supportedLanguagesForDisplay: any[] = [];
  supportedLanguages: any;
  private _bpConfig: { gMapApiKey: any } = { gMapApiKey: undefined };
  private readonly _loadMapState = signal<boolean>(false);
  readonly loadMap$ = toObservable(this._loadMapState);
  private readonly httpClient = inject(HttpClient);
  sendtranslationValue(value: any) {
    this.translationState.set(value);
  }
  sendSelectedLanguage(value: any) {
    this.languageState.set(value);
  }

  setTranslationData(data: any) {
    this.translatedArray = data;
  }
  getTranslationData() {
    return this.translatedArray;
  }

  setLoadMap(load: boolean): void {
    this._loadMapState.set(load);
  }

  getLoadMap() {
    return this.loadMap$;
  }

  public set featureFlags(flags: any) {
    this._featureFlags = flags;
  }

  public get featureFlags() {
    return this._featureFlags;
  }

  /**
   * @description To be replaced by actual API. Gives list of all supported languages
   * @returns list of languages
   * !IMPORTANT: While testing with actual API, ensure error scenarios are also handled
   */
  public getAllSupportedLanguages(): Observable<any> {
    const res = require("../../shared/components/language-selection/language-list.json");
    return of(res).pipe(delay(800));
  }

  public set supportedLanguagesForDisplay(languages: any[]) {
    const defaultLangs = ["en", "de"];
    const langCodes = languages.map((lang) => lang.localeCode);
    langCodes.push(...defaultLangs);
    this.setSupportedLanguageByCode(langCodes);
    this._supportedLanguagesForDisplay = languages;
  }

  public get supportedLanguagesForDisplay(): any[] {
    return this._supportedLanguagesForDisplay;
  }

  public getConfig(): Observable<any> {
    const url = `${environment.proxyUrl}/businessPortal/app/admin/config`;
    return this.httpClient.get<any>(url);
  }

  public set allClientConfig(secrets: any) {
    this._bpConfig = secrets;
  }

  public get allClientConfig(): any {
    return this._bpConfig;
  }

  public getBpConfigurations(): void {
    if (!this._bpConfig.gMapApiKey) {
      this.getConfig().subscribe((secrets: any) => {
        this.allClientConfig = secrets;
        this.setLoadMap(true);
      });
    }
  }

  public getAllFeatureFlags(): Observable<any> {
    let featureFlags = require("../../shared/feature-toggle/feature-toggle.prod.json");
    if (environment.environment === "dev") {
      featureFlags = require("../../shared/feature-toggle/feature-toggle.json");
    } else if (environment.environment === "int") {
      featureFlags = require("../../shared/feature-toggle/feature-toggle.int.json");
    }
    return of(featureFlags).pipe(delay(800));
  }

  public setSupportedLanguageByCode(languages: string[]) {
    this.supportedLanguages = languages;
  }

  public getSupportedLanguageByCode(): string[] {
    this.supportedLanguages = this.supportedLanguages ?? ["en-GB", "de-DE"];
    return this.supportedLanguages;
  }
}
